// A troca de tema como um trilho: o sol à esquerda, a lua à direita, e a
// bolinha embaixo do tema ATIVO. O ativo aparece inteiro; o outro fica
// apagado, mostrando que existe e para onde o clique leva. Um clique troca.
//
// `role="switch"` porque é isso que ele é — dois estados, um clique —, e o
// leitor de tela anuncia "Tema claro, ligado/desligado" em vez de um botão
// com um emoji sem nome.
import { useTema } from './tema';
import estilos from './SeletorDeTema.module.css';

export function SeletorDeTema() {
  const { tema, alternar } = useTema();
  const claro = tema === 'light';
  return (
    <button
      type="button"
      role="switch"
      aria-checked={claro}
      aria-label="Tema claro"
      title={claro ? 'Trocar para o tema escuro' : 'Trocar para o tema claro'}
      className={estilos.trilho}
      data-tema={tema}
      onClick={alternar}
    >
      <span className={estilos.bolinha} aria-hidden="true" />
      <span className={`${estilos.icone} ${claro ? estilos.ativo : ''}`} data-icone="sol" aria-hidden="true">☀️</span>
      <span className={`${estilos.icone} ${claro ? '' : estilos.ativo}`} data-icone="lua" aria-hidden="true">🌙</span>
    </button>
  );
}
